import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { convertEpochToDateString, GlobalFunctions } from '@global/GlobalFunctions';
import { Action, ActionEdit } from '@services/actions-data.service';
import { AuthenticationService } from '@services/authentication.service';
import { Subject } from 'rxjs';

/** ActionEditsDialogData */
export class ActionEditsDialogData {

	/** actionEdits */
	public actionEdits: ActionEdit[];

	/** action */
	public action: Action;

	/** visiblePropertNames */
	public visiblePropertNames: { propName: string, visibleName: string, function?: any, funcParam?: any }[];
}

@Component({
	selector: 'app-action-edits',
	templateUrl: './action-edits.component.html',
	styleUrl: './action-edits.component.scss'
})
export class ActionEditsComponent implements OnInit, OnDestroy {

	/** Form Group */
	dialogForm: FormGroup;

	/** Observable Subject Finalise */
	private finalise = new Subject<void>();

	/** actionEdits */
	public actionEdits: ActionEdit[] = [];

	/** action */
	public action: Action;

	/** fields */
	public fields: Object = { text: "PreviousAction", value: "ActionEditID" };

	/** visiblePropertyNames */
	public visiblePropertyNames: { propName: string, visibleName: string, function?: any, funcParam?: any }[] = [];

	/**
	 * Default Constructor
	 * @param dialogRef Referense to the Dialog box
	 * @param dialogData object interface
	 */
	constructor(
		public dialogRef: MatDialogRef<ActionEditsComponent>,
		@Inject(MAT_DIALOG_DATA) public dialogData: ActionEditsDialogData
	) {
		this.actionEdits = dialogData.actionEdits;
		this.action = dialogData.action;
		this.visiblePropertyNames = dialogData.visiblePropertNames;
	}

	/**
	 * Page On Initialise Event Handler
	 */
	ngOnInit(): void {
	}

	/**
	 * Page On Destroy Event Handler
	 */
	ngOnDestroy(): void {
		try {
			// Unsubscribe from all subscriptions
			this.finalise.next();
			this.finalise.complete();
		}
		catch { }
	}

	/**
	 * Cancel button for dialog
	 */
	onCancelClick(): void {
		this.dialogRef.close();
	}

	/**
	 * getChangedPropeties
	 * @param actionEdit actionEdit 
	 */
	getChangedPropeties(actionEdit: ActionEdit): { name: string, old: string, new: string }[] {
		const previousAction: Action = JSON.parse(actionEdit.PreviousAction)[0];
		const newAction: Action = JSON.parse(actionEdit.NewAction)[0];

		const differingProperties: { name: string, old: string, new: string }[] = [];

		Object.entries(newAction).forEach((prop) => {
			const propLabel: keyof Action = prop[0] as keyof Action;
			const oldProp = previousAction[propLabel];
			if (oldProp != undefined && prop[1] != oldProp) {
				const _propData = this.visiblePropertyNames.find((x) => x.propName == propLabel);
				if (_propData) {
					differingProperties.push({
						name: _propData.visibleName,
						old: !_propData.function ? oldProp.toString() : _propData.function(previousAction, _propData.funcParam),
						new: !_propData.function ? prop[1] : _propData.function(newAction, _propData.funcParam)
					});
				}
			}
		});

		return differingProperties;
	}

	/**
	 * convertEpoch
	 * @param epoch
	 * @returns
	 */
	convertEpoch(epoch: number): string {
		/** Use the Global Function */
		return convertEpochToDateString(epoch);
	}
}
